/** @jsx jsx */
import { jsx } from "theme-ui";
import {
  setUser,
  setUserToken,
  showAlert,
} from "gatsby-plugin-hfn-profile/state/actions";
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchSrcmAPI } from "sites-common/service-wrappers/profile-api";
import { fget } from "gatsby-plugin-hfn-profile/components/Login";
import { useFirebase } from "react-redux-firebase";
import { selectorGlobalConfig } from "gatsby-plugin-hfn-profile/state/selectors";
import getMandatoryEnv from "sites-common/utils/getMandatoryEnv";

const OneAuthPage = () => {
  const firebase = useFirebase();
  const dispatch = useDispatch();
  const { mySrcmConfig } = getMandatoryEnv(["mySrcmConfig"]);
  const isBrowser = () => typeof window !== "undefined";
  const { enabledFireStore } = useSelector(selectorGlobalConfig);
  const firebaseStoreAuth =
    isBrowser() && enabledFireStore ? firebase.auth() : null;
  const [auth, setAuth] = useState(null);
  const apiCallCount = useRef(0);
  useEffect(() => {
    import("hfnauth/main");
    if (typeof window !== "undefined") {
      const storedAuth = localStorage.getItem("pstate");
      setAuth(storedAuth ? JSON.parse(storedAuth) : null);
    }
  }, []);

  useEffect(() => {
    if (auth?.user?.id) {
      dispatch(setUser(auth?.user));
      dispatch(
        setUserToken({
          token: auth?.srcmtoken?.token,
          fbName: "",
          user: auth?.user.email || "",
          uid: auth?.user?.user_firebase_uid,
          type: "fb",
        })
      );
      localStorage.setItem("authInfo", JSON.stringify(auth?.user));
      window.location.href = `${window.location.origin}${localStorage.getItem(
        "LandingPage"
      )}`;
    }
  }, [auth?.srcmtoken?.token, auth?.user, dispatch]);

  const handleAuth = useCallback((status) => {
    const oneAuthElement = document.querySelector("hfn-oneauth");
    if (
      oneAuthElement &&
      typeof oneAuthElement.handleProfileAuthentication === "function"
    ) {
      oneAuthElement.handleProfileAuthentication(status);
    }
  }, []);

  const getUserProfile = useCallback(
    async ({ access_token }) => {
      try {
        apiCallCount.current += 1;
        if (apiCallCount.current < 4) {
          const { getSRCMProfile } = await import("hfnauth/main");
          const resData = await getSRCMProfile({
            srcmBaseURL: `${mySrcmConfig?.profileServer}/`,
            xClientId: mySrcmConfig?.baseClient,
            queryParams: [
              "id",
              "name",
              "user_email",
              "mobile",
              "ref",
              "country",
              "country_id",
              "state",
              "state_id",
              "city",
              "city_id",
              "srcm_group",
              "srcm_group_id",
              "citizen_of_country",
              "citizen_id",
              "resp_prefect",
              "current_preceptor_id",
              "age",
              "gender",
              "record_type",
              "user_roles",
              "has_positions",
              "street",
              "street2",
              "street3",
              "street4",
              "postal_code",
              "first_name",
              "last_name",
              "photo_url",
              "user_firebase_uid",
            ].join(","),
          });
          if (Object.keys(resData.data)?.length > 0) {
            const newsrcmprofile = resData.data || {};
            if (!newsrcmprofile?.user_firebase_uid) {
              getUserProfile(access_token);
              return;
            }
            await fetchSrcmAPI(
              "get-token",
              access_token,
              "GET",
              {},
              {},
              true,
              {},
              "firestoreClient"
            )
              .then(async (res) => {
                await firebaseStoreAuth
                  .signInWithCustomToken(res)
                  .then(() => {
                    // console.log("2nd Firebase Response", r);
                  })
                  .catch(() => {
                    dispatch(showAlert({ title: "Error FirebaseStoreApp" }));
                  });
              })
              .catch(() => {
                dispatch(showAlert({ title: "Error FirebaseStoreApp" }));
              });
            dispatch(
              setUser(fget(newsrcmprofile, newsrcmprofile?.user_firebase_uid))
            );
            const d = new Date();
            d.setHours(d.getHours() + 8);
            const ts = d.valueOf();
            dispatch(
              setUserToken({
                token: access_token,
                fbName: newsrcmprofile.name,
                user: newsrcmprofile.email,
                uid: newsrcmprofile.user_firebase_uid,
                ts,
                type: "fb",
              })
            );
            localStorage.setItem(
              "authInfo",
              JSON.stringify({ ...newsrcmprofile, tokenData: access_token })
            );
            handleAuth(true);
            window.location.href = `${
              window.location.origin
            }${localStorage.getItem("LandingPage")}`;
          } else {
            handleAuth(false);
          }
        } else {
          handleAuth(false);
        }
      } catch {
        handleAuth(false);
      }
    },
    [
      dispatch,
      firebaseStoreAuth,
      handleAuth,
      mySrcmConfig?.baseClient,
      mySrcmConfig?.profileServer,
    ]
  );

  useEffect(() => {
    const initializeAuthProfile = async () => {
      await import("hfnauth/main");

      const authProfileElement = document.querySelector("hfn-auth");
      if (authProfileElement) {
        authProfileElement.loginCallback = async (response) => {
          try {
            const user = response?.data;
            if (!user?.access_token) {
              handleAuth(false);
              return false;
            }
            await getUserProfile({
              access_token: user.access_token,
            });
            return true;
          } catch {
            handleAuth(false);
          }
          return true;
        };
      }
    };

    initializeAuthProfile();
  }, [getUserProfile, handleAuth]);
  return <div />;
};

export default OneAuthPage;
